"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValues = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right5"));
var _cccisdColorPicker = require("cccisd-color-picker");
var _settingsWrapper = _interopRequireDefault(require("../../../../helpers/settingsWrapper"));
var _style = _interopRequireDefault(require("./style.css"));
var _color = _interopRequireDefault(require("color"));
var _modalOn = _interopRequireDefault(require("./modalOn.png"));
var _modalOff = _interopRequireDefault(require("./modalOff.png"));
var _aspectRatioOptions = _interopRequireDefault(require("./aspectRatioOptions.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var initialValues = {
  mustTakeInOrder: true,
  showLastVisited: false,
  showLessonNum: true,
  showProgressBubbleNum: true,
  showLessonsInModal: false,
  suppressOnComplete: true,
  aspectRatio: '',
  highlighting: '',
  requiredHighlightColor: '#c5422b',
  optionalHighlightColor: '#6f6f6f',
  baseColor: '#176987',
  buttonColors: {
    start: '#176987',
    resume: '#a95a14',
    replay: '#636466'
  },
  progressBubbleColors: {
    resume: 'primaryColor',
    replay: '#43a047'
  }
};
exports.initialValues = initialValues;
var Settings = function Settings(_ref) {
  var questSettings = _ref.questSettings,
    values = _ref.values;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showColors = _useState2[0],
    setShowColors = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "mustTakeInOrder",
    component: _cccisdFormik.CccisdToggle,
    label: "User must take surveys in order"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "suppressOnComplete",
    component: _cccisdFormik.CccisdToggle,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Suppress completion message from Data Collection Wave", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "When a user completes all required lessons in all modules, do you want the Data Colleciton Wave completion message to show?"), /*#__PURE__*/_react["default"].createElement("p", null, "Toggling this setting to ", /*#__PURE__*/_react["default"].createElement("b", null, "NO"), " allows the message to show."), /*#__PURE__*/_react["default"].createElement("p", null, "Toggling this setting to ", /*#__PURE__*/_react["default"].createElement("b", null, "YES"), " suppresses the message and kicks users right back to the dashboard upon completing the final survey."))
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "showLastVisited",
    component: _cccisdFormik.CccisdToggle,
    label: "Show Last Visited Date"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "showLessonNum",
    component: _cccisdFormik.CccisdToggle,
    label: "Show Lesson Numbers"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "showProgressBubbleNum",
    component: _cccisdFormik.CccisdToggle,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Show Progress Bubble Numbers", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Show each lesson number within the progress bubble on the course player."
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "showLessonsInModal",
    component: _cccisdFormik.CccisdToggle,
    label: /*#__PURE__*/_react["default"].createElement("span", null, "Show Lessons in Modal", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].lessonInModalTooltip
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h6", null, "YES"), /*#__PURE__*/_react["default"].createElement("img", {
        src: _modalOn["default"],
        alt: "modal on"
      })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h6", null, "NO"), /*#__PURE__*/_react["default"].createElement("img", {
        src: _modalOff["default"],
        alt: "modal off"
      })))
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))
  }), values.showLessonsInModal ? /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "aspectRatio",
    component: _cccisdFormik.CccisdSelect,
    label: "Force aspect ratio",
    options: _aspectRatioOptions["default"],
    style: {
      width: 'auto'
    }
  }) : null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "highlighting"
  }, function (fieldProps) {
    // avoids React warning for passing `value` prop of null
    if (!fieldProps.field.value) {
      fieldProps.field.value = '';
    }
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdSelect, _extends({}, fieldProps, {
      label: /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-primary"
      }, "Highlighting", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("ul", {
          className: _style["default"].highlightOptions
        }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, "Required:"), " Highlights all lessons that have the \"Required\" setting toggled ON. Modules will be highlighted if they contain one at least one required survey."), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("b", null, "Optional:"), " Highlights all lessons that have the \"Required\" setting toggled OFF. Modules will be highlighted if they contain exclusively non-required surveys."))),
        placement: "top"
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))),
      options: [{
        value: '',
        label: '-- None --'
      }, {
        value: 'required',
        label: 'Required'
      }, {
        value: 'optional',
        label: 'Optional'
      }]
    }));
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "control-label"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: 'text-primary ' + _style["default"].toggleColors,
    onClick: function onClick() {
      return setShowColors(function (prev) {
        return !prev;
      });
    }
  }, showColors ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null), "Color Settings"))), showColors && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].colorBlock
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "baseColor",
    label: "Base Color"
  }, function (fieldProps) {
    var colorValue = (0, _color["default"])((0, _cccisdColorPicker.getColor)(fieldProps.field.value));
    var contrast = colorValue.contrast((0, _color["default"])('#FBFBFB'));
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", {
      className: "control-label"
    }, "Base Color"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdColorPicker, fieldProps), contrast <= 4.4 && /*#__PURE__*/_react["default"].createElement("div", {
      className: "alert alert-warning"
    }, "Note: The selected color may be too light. You may wish to choose a darker color for greater contrast."));
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "buttonColors.start",
    component: _cccisdFormik.CccisdColorPicker,
    label: "Start Button"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "buttonColors.resume",
    component: _cccisdFormik.CccisdColorPicker,
    label: "Resume Button"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "buttonColors.replay",
    component: _cccisdFormik.CccisdColorPicker,
    label: "Replay Button"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "progressBubbleColors.resume",
    component: _cccisdFormik.CccisdColorPicker,
    label: "Progress Bubble - Resume"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "progressBubbleColors.replay",
    component: _cccisdFormik.CccisdColorPicker,
    label: "Progress Bubble - Complete"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "requiredHighlightColor",
    component: _cccisdFormik.CccisdColorPicker,
    label: "Required Highlight Color"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "optionalHighlightColor",
    component: _cccisdFormik.CccisdColorPicker,
    label: "Optional Highlight Color"
  })));
};
var _default = (0, _settingsWrapper["default"])({
  initialValues: initialValues
})(Settings);
exports["default"] = _default;